import Navbar from "../components/navbar"
import Footer from "../components/footer"
import front_model from '../images/front-model.jpg'
import LoadingOverlay from "../components/loading"
import emptyList from "../components/empty_list"
import { useEffect, useState } from "react"
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCart } from "../hooks/add_to_cart"
import { FaTimes } from "react-icons/fa";
import {LiaTimesSolid} from "react-icons/lia";
import { ProductDetails } from "../components/product_details"
import { useCookies } from "react-cookie"
import { useNavigate, useParams } from "react-router-dom"
import { BarLoader } from "react-spinners"
import { PayPalButtons } from "@paypal/react-paypal-js";
import { IoMdCheckmarkCircleOutline } from "react-icons/io"

export default function WigRevamp({ route }) {
    const [pageLoading, setPageLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [featured_prod, setFeaturedProd] = useState([]);
    const [products, setProducts] = useState([]);
    const { addToCart, checkItemInCart, removeItem, convertAmount } = useCart();
    const [showModal, setShowModal] = useState(false);
    const [showDetails, setShowDetails] = useState({});
    const [cookies, removeCookie] = useCookies();
    const navigate = useNavigate();
    const [payment, setPayment] = useState("cod");
    const [pageData, setPageData] = useState({});
    const {reference} = useParams();

    return(
        <div className="w-full h-auto">
            {pageLoading && <LoadingOverlay />}
            <Navbar />
            <div className="max-w-6xl mx-auto px-4 py-6">
                
            </div>
            <Footer />
        </div>
    )
}
